import { Button, Fieldset, scrollToFirstError } from '@ahmdigital/ui';
import { Form, useFormikContext } from 'formik';
import { isEmpty, isNil } from 'lodash/fp';
import { useEffect } from 'react';

import { CaptureFormState, LeadType } from '../../types';
import FormFieldsForComponent from '../fields';
import styles from '../../styles.module.sass';

type LeadFormProps = {
  analyticsLabel?: string;
  captureFormState?: CaptureFormState;
  leadType: LeadType;
  submitButtonText: string;
  isLoading?: boolean;
};

// @ts-expect-error - Automatic, Please fix when editing this file
const restoreFormikSession = (formik) => formik;

const LeadForm = ({ analyticsLabel, captureFormState, leadType, submitButtonText, isLoading }: LeadFormProps) => {
  const formik = useFormikContext();
  const { handleSubmit, errors, isSubmitting, setFieldTouched, setFieldValue, touched, values } = formik;
  const setFormikTouched = captureFormState?.setFormikTouched;
  const setFormikErrors = captureFormState?.setFormikErrors;

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'isMember' does not exist on type '{}'.
  const isMember: boolean = values?.isMember;
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'memberCallbackReason' does not exist on type '{}'.
  const noReasonGiven: boolean = values?.memberCallbackReason === '';
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'memberCallbackReason' does not exist on type '{}'.
  const wantingToLeave: boolean = values?.memberCallbackReason === 'Wanting to leave';

  const showSubmitButton = !isMember || noReasonGiven || wantingToLeave;

  // ErrorSummary component requires formik context values. This allows us to pass the errors and touched objects outside the LeadCaptureForm
  useEffect(() => {
    if (setFormikErrors) {
      setFormikErrors(errors);
    }
    if (isSubmitting && !isEmpty(errors)) {
      scrollToFirstError();
    }
  }, [errors, isSubmitting, setFormikErrors]);

  useEffect(() => {
    if (setFormikTouched) {
      setFormikTouched(touched);
    }
  }, [touched, setFormikTouched]);

  return (
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element; }' is missing the following properties from type 'Pick<DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>, "method" | "about" | ... 260 more ... | "onPointerLeaveCapture">': placeholder, onPointerEnterCapture, onPointerLeaveCapture
    <Form>
      <Fieldset>
        <FormFieldsForComponent
          component={leadType.component}
          setFieldTouched={setFieldTouched}
          setFieldValue={setFieldValue}
          values={values}
        />
        {showSubmitButton && (
          <Button
            analyticsLabel={{ label: isNil(analyticsLabel) ? submitButtonText : analyticsLabel }}
            disabled={isSubmitting}
            // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '(e?: FormEvent<HTMLFormElement> | undefined) => void' is not assignable to type 'MouseEventHandler<ClickableElement>'.
            onClick={handleSubmit}
            type="submit"
            variant={styles.button}
            isLoading={isLoading}
          >
            {submitButtonText}
          </Button>
        )}
      </Fieldset>
    </Form>
  );
};

export default LeadForm;
